export default "__VITE_ASSET__LB6jJhHn__"